export const DAILY_REPORT = 'date';
export const ADVERTISER_REPORT = 'advertiser';
export const SOURCE_REPORT = 'source';
export const COUNTRY_REPORT = 'country';
export const LANDING_REPORT = 'landing';
